import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import ReviewsSection from './components/ReviewsSection';
import CTASection from './components/CTASection';
import AboutSection from './components/AboutSection';

const homeSchemas = {
  org: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '073漫画网',
    url: 'http://dqcmwfc.com/',
    description: '在线免费阅读下拉式漫画平台，操作便捷、加载快速，追漫不受限制。',
  },
  webSite: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '073漫画网',
    url: 'http://dqcmwfc.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://dqcmwfc.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  webPage: {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '洞洞杂货铺漫画-在线免费阅读下拉式漫画-073漫画网',
    description: '在线免费阅读下拉式洞洞杂货铺漫画尽在073漫画网，操作便捷、加载快速，追漫不受限制。',
    url: 'http://dqcmwfc.com/',
    about: {
      '@type': 'Thing',
      name: '漫画在线阅读',
    },
  },
};

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchemas.org) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchemas.webSite) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchemas.webPage) }}
        />
        <HeroBanner />
        <CategoryNav />
        <HotComics />
        <CTASection />
        <LatestUpdates />
        <ReviewsSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}